import { useContext } from "react";
import { AuthContext } from "../context/Auth/AuthContext";
import { SettingsContext } from "../context/Settings/SettingsContext";

// feat_404 (SOPORTE-F2) — ¿ve este usuario la sección/botón Soporte?
// Sólo admin de empresa (no superadmin) y con el flag `supportEnabled` de SU
// empresa prendido. El admin recibe todos los settings (SettingController),
// así que no hace falta publicKeys. El gate real es del backend
// (requireSupportClient); esto sólo evita dibujar lo que daría 403.
const useSupportAccess = () => {
  const { user } = useContext(AuthContext);
  const { getSetting } = useContext(SettingsContext);
  return (
    !!user &&
    user.profile === "admin" &&
    !user.isSuperAdmin &&
    getSetting("supportEnabled") === "true"
  );
};

export default useSupportAccess;
